import { Heart, ShieldCheck, Zap, Activity, Brain, Target } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function OurSpecialisedServices() {
  const services = [{
    id: 1,
    title: "Back Pain Treatment",
    description: "Expert care for lower back pain, sciatica, and spinal conditions using evidence-based techniques.",
    icon: null,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/lower_back_anatomy.png"
  }, {
    id: 2,
    title: "Knee and Hip Arthritis Management",
    description: "Comprehensive rehabilitation programmes to reduce pain and improve mobility for knee conditions.",
    icon: Heart,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/knee_joint_anatomy.png"
  }, {
    id: 3,
    title: "Shoulder Pain Rehabilitation",
    description: "Targeted treatment for rotator cuff injuries, instability, frozen shoulder, and post-operative recovery.",
    icon: ShieldCheck,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/shoulder_rehabilitation.png"
  }, {
    id: 4,
    title: "Sports Injury Treatment",
    description: "Specialised care for athletes with sports-related injuries and performance optimisation.",
    icon: Zap,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/soccer_sports_injury.png"
  }, {
    id: 5,
    title: "Neck Pain",
    description: "Expert treatment for neck pain, spondylosis, whiplash, neck related headaches and tension-related discomfort using manual therapy and targeted exercises.",
    icon: Activity,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/neck_pain_treatment.png"
  }, {
    id: 6,
    title: "Chronic Pain Management",
    description: "Long-term pain management strategies using modern techniques to improve quality of life. Treating conditions such as Fibromyalgia.",
    icon: Brain,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/chronic_pain_management.png"
  }, {
    id: 7,
    title: "Foot and Ankle Pain",
    description: "Specialist treatment for common foot conditions including, arthritis, acute and chronic sprains and plantar fasciitis.",
    icon: Target,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/injury_prevention_assessment.png"
  }, {
    id: 8,
    title: "Acupuncture",
    description: "Dry needling acupuncture therapy for effective pain relief and management of acute and chronic pain conditions.",
    icon: null,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1405447/img/acupuncture_treatment_needles.png"
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4 tracking-wide">
            Our Specialised Services
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            At Align Physiotherapy, we provide expert, evidence-based treatment tailored to your individual needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className="bg-white border border-border shadow-soft hover:shadow-medium transition-all duration-[250ms] ease-out hover:-translate-y-1 py-6">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center overflow-hidden">
                      {service.image ? <img src={service.image} alt={service.title} className="w-full h-full object-cover" /> : IconComponent && <IconComponent className="w-6 h-6 text-primary" />}
                    </div>
                    <CardTitle className="text-xl md:text-2xl font-display font-semibold text-foreground">
                      {service.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-base text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="text-center">
          <Link to="/ServicesPage">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary-hover shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-150">
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}